module.exports = __webpack_public_path__ + "img/PDF.7a072d0a.svg";